import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';

import { getBlockGapValue } from '../../../utils/helpers';

// Importing the stylesheet here is what creates the block's style-index.css
// entry; wp-scripts does not pick style.scss up from block.json alone.
import '../style.scss';

const ALLOWED_BLOCKS = [ 'brandy/statement-line' ];

const LINES = [ '1,428 apps', '621,500+ screens', '323,900 flows' ];

// `align` is inert on WP 7.1 — core/paragraph moved text alignment to
// supports.typography.textAlign. Both keys are set so the seed centres on
// current and older WordPress alike; together they still emit one class.
const TEMPLATE = LINES.map( ( content ) => [
	'brandy/statement-line',
	{},
	[
		[
			'core/paragraph',
			{
				content,
				fontSize: 'fluid-5-xl',
				align: 'center',
				style: { typography: { textAlign: 'center' } },
			},
		],
	],
] );

/**
 * The scroll scrub is driven by the host's position in the viewport, which has
 * no meaning inside the editor iframe. Lines render stacked and fully opaque
 * here, reusing the frontend's static-mode class so there is one static layout
 * to maintain rather than two.
 *
 * The block takes no attributes of its own — line spacing comes from blockGap,
 * everything else is decided in style.scss and view.js.
 */
export default function Edit( { attributes } ) {
	const { style } = attributes;

	/*
	 * blockGap is skip-serialized, so nothing sets --statement-gap here unless
	 * this does. Without it the editor silently ignores Block spacing and
	 * falls back to the stylesheet default while the front end honours it —
	 * the exact editor/front-end disagreement getBlockGapValue exists to stop.
	 */
	const gap = getBlockGapValue( style?.spacing?.blockGap );

	const blockProps = useBlockProps( {
		className: 'brandy-scroll-statement brandy-scroll-statement--static',
		// Left unset when empty so the stylesheet's fallback chain decides,
		// the same way render.php omits the property.
		style: gap ? { '--statement-gap': gap } : undefined,
	} );

	const innerBlocksProps = useInnerBlocksProps(
		{ className: 'brandy-scroll-statement__track' },
		{
			allowedBlocks: ALLOWED_BLOCKS,
			template: TEMPLATE,
		}
	);

	return (
		<div { ...blockProps }>
			<div className="brandy-scroll-statement__viewport">
				<div { ...innerBlocksProps } />
			</div>
		</div>
	);
}
